import React from 'react';
import img1 from '../Image/toolsbd/Screenshot (78).png'
import img2 from '../Image/toolsbd/Screenshot (79).png'
import img3 from '../Image/toolsbd/Screenshot (81).png'
import img4 from '../Image/toolsbd/Screenshot (83).png'
import { ImPointRight } from 'react-icons/im';
import Footer from './Footer';

const ToolsBD = () => {
    return (
        <div className='text-white bg-black'>
            <div >
                <h1 className='text-center mb-12 text-5xl font-bold text-primary'>Explore More about ToolsBD</h1>
                <div class="carousel shadow-2xl mx-24 rounded-[20px] h-[500px]">
                    <div id="item1" class="carousel-item w-full">
                        <img src={img1} class="w-full" />
                    </div>
                    <div id="item2" class="carousel-item w-full">
                        <img src={img2} class="w-full" />
                    </div>
                    <div id="item3" class="carousel-item w-full">
                        <img src={img3} class="w-full" />
                    </div>
                    <div id="item4" class="carousel-item w-full">
                        <img src={img4} class="w-full" />
                    </div>

                </div>
                <div class="flex justify-center w-full py-2 gap-2">
                    <a href="#item1" class="btn btn-xs">1</a>
                    <a href="#item2" class="btn btn-xs">2</a>
                    <a href="#item3" class="btn btn-xs">3</a>
                    <a href="#item4" class="btn btn-xs">4</a>
                </div>
            </div>
            <p><a className='btn bg-green-500 w-56 ml-[40%] text-center my-12' href="https://my-12th-assignment-toolsbd.web.app/">Live side</a></p>
            <div className='mt-12  text-5xl font-bold'>
                <h1 className='text-center text-primary'>Details Aout Project</h1>
                <div className='mx-[25%]  mb-12'>
                    <p className='my-5 text-xl  font-bold'><ImPointRight className='text-primary'></ImPointRight>This project is about tools manufacturer
                    </p>
                    <p className='text-xl my-5 font-bold'><ImPointRight className='text-primary'></ImPointRight>The home pase has a banner, some demo tools, business summary and some user review.
                    </p>
                    <p className='text-xl my-5 font-bold'><ImPointRight
                        className='text-primary'></ImPointRight>There are a dashboad on header but user can't see it without login.
                    </p>
                    <p className='text-xl my-5 font-bold'><ImPointRight
                        className='text-primary'></ImPointRight>The purchase button show the information about the product you clicked and you can book the product from this purchase page
                    </p>
                    <p className='text-xl my-5 font-bold'><ImPointRight className='text-primary'></ImPointRight>on dashboard some route can see only users and some routs can see only admin.</p>
                </div>
            </div>
            <div>
                <h1 className='text-center text-primary text-5xl font-bold'>Technology used:</h1>
                <p className='mx-[25%] pb-12 text-xl  font-bold'><ImPointRight className='text-primary'></ImPointRight> React JS, React Router, React Firebase Hook, Tailwind, Firebase, Node Js, MongoDB, JWT, Heroku, React Query, Daisy UI, React-Form-Hook.

                </p>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default ToolsBD;